import axios from "axios";

// If REACT_APP_BACKEND_URL is set (e.g. Emergent preview, Railway/Render backend)
// we call `${BACKEND_URL}/api/...`. When deployed to Cloudflare Pages the env var
// is left empty and calls hit the same-origin `/api/...` routes served by
// Cloudflare Pages Functions in /functions/api/.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const formatNumber = (n) => {
    if (n == null) return "—";
    if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + "M";
    if (n >= 1_000) return (n / 1_000).toFixed(n >= 10_000 ? 0 : 1) + "K";
    return String(n);
};
